import { Container, Snackbar, Alert } from "@mui/material";
import { useSuperChatLogList } from "./useSuperChatLogDashboard";
import SuperChatLog from "@/templates/SuperChatLog";
import { ChatSession } from "@/organism/SuperChatLog/List";

/**
 * 채팅 로그 리스트 페이지
 *
 * @description QNA 컨텐츠 관리 페이지를 참고하여 Atomic Design 패턴으로 구현
 *
 * @author Max <sud665@ymjlab.com>
 *
 * @version 1.0.0
 * @since 2025-01-16
 */
export default function SuperChatLogList() {
  const {
    sessions,
    pagination,
    loading,
    snackbarOpen,
    snackbarMessage,
    onSnackbarClose,
  } = useSuperChatLogList();

  // ChatSessionDto를 ChatSession으로 변환
  const transformedSessions: ChatSession[] = sessions.map((session) => ({
    ...session,
    primaryCategory: session.sessionType,
  }));

  return (
    <>
      <Container maxWidth={"xl"}>
        <SuperChatLog.List
          page={pagination.page}
          count={pagination.total}
          list={transformedSessions}
          isLoading={loading}
        />
      </Container>

      {/* 에러/성공 메시지 스낵바 */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={onSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={onSnackbarClose}
          severity={
            snackbarMessage.includes("실패") || snackbarMessage.includes("에러")
              ? "error"
              : "success"
          }
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
